import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import Checkbox from 'components/common/checkbox';
import ControlContainer from 'components/common/forms/horizontal_control_container';
import DropdownMenu from 'components/common/dropdown_menu';
import { FormInputSectionTypes } from 'models/external_action_form';
import Input from 'components/common/input';

export default function InputSection({ error, section, value, updateState }) {
  let ControlInput = getInputComponent(_.get(section, 'input.type', null));
  const onChange = useCallback(
    newValue => {
      updateState({
        [section.attr]: newValue,
      });
    },
    [section, updateState]
  );

  if (!ControlInput) {
    return null;
  }

  return (
    <ControlContainer
      control={<ControlInput input={section.input} onUpdate={onChange} value={value} />}
      label={section.label}
      description={section.hint}
      error={error}
    />
  );
}

InputSection.propTypes = {
  error: PropTypes.string,
  section: PropTypes.objectOf({
    type: PropTypes.string,
  }).isRequired,
  value: PropTypes.any,
  updateState: PropTypes.func.isRequired,
};

function getInputComponent(type) {
  switch (type) {
    case FormInputSectionTypes.text:
      return TextInputSection;
    case FormInputSectionTypes.select:
      return DropdownInput;
    case FormInputSectionTypes.checkbox:
      return CheckboxInput;
    default:
      return null;
  }
}

export function TextInputSection({ input = {}, onUpdate, value }) {
  const onChange = e => onUpdate(e.target.value);
  return (
    <StyledInput
      className="externalForm-inputSection-text"
      onChange={onChange}
      value={value}
      placeholder={input.placeholder}
    />
  );
}

const StyledInput = styled(Input)`
  border-radius: 4px;
  border: 1px solid ${p => p.theme.colors.gray300};
  padding-left: ${p => p.theme.spacing.insetSmall};
`;

TextInputSection.propTypes = {
  input: PropTypes.objectOf({
    placeholder: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
};

export function DropdownInput({ input = {}, onUpdate, value }) {
  let options = _.map(input.options, option => {
    return {
      label: option.text,
      value: option.value,
    };
  });

  return (
    <DropdownMenu
      className="externalForm-inputSection-dropdown"
      onSelect={onUpdate}
      value={value}
      options={options}
      placeholder={input.placeholder}
      searchable
    />
  );
}

DropdownInput.propTypes = {
  input: PropTypes.objectOf({
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.objectOf({
        text: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
};

export function CheckboxInput({ input = {}, onUpdate, value }) {
  const onChange = e => onUpdate(!value);

  return (
    <Checkbox
      wrapperClassName="externalForm-inputSection-checkbox"
      value={value}
      onChange={onChange}
      label={input.text}
      checked={value}
    />
  );
}

CheckboxInput.propTypes = {
  input: PropTypes.objectOf({
    text: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/external_form/input_section.js